var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.718 1.445 5.938h29.117L16 18.718zM10.2 15.954 0 24.907V6.994l10.2 8.96z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.527 17.115 16 21.047l4.473-3.932 10.088 8.861H1.431l10.095-8.861zM21.8 15.954 32 6.994v17.92l-10.2-8.96z"
  })));
};

export default SvgEmail;